import { createSlice } from "@reduxjs/toolkit";
import { TagValueDTO, TagsDictionaryDTO } from "../../models/TagValue.model";
import { GetTagsValues, GetTagsDictionary } from "../thunks/TagsValueThunks";

export interface TagValueState {
  tagsValues: TagValueDTO[];
  tagsDictionary: TagsDictionaryDTO[];
  phoneTagsDictionary: TagsDictionaryDTO[];
  emailTagsDictionary: TagsDictionaryDTO[];
  template: string;
  processedTemplate: string;
  loading: boolean;
  dictLoading: boolean;
  error: string | null;
  initialized: boolean;
}

const initialState: TagValueState = {
  tagsValues: [],
  tagsDictionary: [],
  phoneTagsDictionary: [],
  emailTagsDictionary: [],
  template: "",
  processedTemplate: "",
  loading: false,
  dictLoading: false,
  error: null,
  initialized: false,
};

const TagValueSlice = createSlice({
  name: "tagValue",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearTagsValues: (state) => {
      state.tagsValues = [];
      state.tagsDictionary = [];
      state.initialized = false;
      state.error = null;
    },
    processTemplate: (
      state,
      action: { payload: { template: string; tags: TagValueDTO[] } },
    ) => {
      state.template = action.payload.template;
      let processedTemplate = action.payload.template;
      action.payload.tags.forEach((tag) => {
        processedTemplate = processedTemplate.replace(
          new RegExp(tag.tagKey, "g"),
          tag.tagValue,
        );
      });
      state.processedTemplate = processedTemplate;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetTagsValues.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetTagsValues.fulfilled, (state, action) => {
        state.loading = false;
        state.tagsValues = action.payload.tagsValues;
        state.initialized = true;
      })
      .addCase(GetTagsValues.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch tags values";
      })
      // -------------------- GetTagsDictionary --------------------
      .addCase(GetTagsDictionary.pending, (state) => {
        state.dictLoading = true;
        state.error = null;
      })
      .addCase(GetTagsDictionary.fulfilled, (state, action) => {
        state.dictLoading = false;
        if (action.meta.arg.group === "PHONE") {
          state.phoneTagsDictionary = action.payload.tagsDictionary || [];
        } else if (action.meta.arg.group === "EMAIL") {
          state.emailTagsDictionary = action.payload.tagsDictionary || [];
        } else {
          state.tagsDictionary = action.payload.tagsDictionary || [];
        }
      })
      .addCase(GetTagsDictionary.rejected, (state, action) => {
        state.dictLoading = false;
        state.error = action.payload || "Failed to fetch tags dictionary";
      });
  },
});

// פונקציה עזר לעיבוד template
export const processTemplateWithTags = (
  template: string,
  tags: TagValueDTO[],
): string => {
  return tags.reduce((processedTemplate, tag) => {
    return processedTemplate.replace(new RegExp(tag.tagKey, "g"), tag.tagValue);
  }, template);
};

export const { clearError, clearTagsValues, processTemplate } =
  TagValueSlice.actions;
export default TagValueSlice.reducer;
